import { Pipe, PipeTransform } from '@angular/core';

import { identificadoresMatrizFilial } from '../identificador-matriz-filial';

@Pipe({
    name: 'identificadorMatrizFilial'
})
export class IdentificadorMatrizFilialPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = identificadoresMatrizFilial.findIndex(identificador => identificador.id === value);
        if (index > -1) {
            return identificadoresMatrizFilial[index].nome;
        }

        return '';
    }
}
